<template>
  <div class="admin-page admin-page-panel">
    <div class="admin-filter-bar">
      <a-select v-model="query.eventId" placeholder="选择赛事" allow-clear style="width:240px; margin-right:10px;">
        <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click="loadData">查询</a-button>
      <a-button type="primary" icon="plus" style="margin-left:10px;" @click="handleAdd">新增组别</a-button>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading" :pagination="false">
      <span slot="groupName" slot-scope="text, record">{{ getGroupName(record.groupId) }}</span>
      <span slot="status" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '停用' }}</a-tag>
      </span>
      <span class="admin-row-actions" slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除吗？" @confirm="handleDelete(record.id)">
          <a style="color:red;">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="visible" :title="form.id ? '编辑组别' : '新增组别'" @ok="handleOk">
      <a-form-model ref="formRef" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="所属赛事" prop="eventId">
          <a-select v-model="form.eventId" placeholder="请选择赛事">
            <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="所属分组">
          <a-select v-model="form.groupId" placeholder="如 男子组 / 女子组 / 混合组" allow-clear>
            <a-select-option v-for="item in groupOptions" :key="item.id" :value="item.id">{{ item.groupName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="组别名称" prop="categoryName">
          <a-input v-model="form.categoryName" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="form.sortOrder" :min="0" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="说明">
          <a-textarea v-model="form.description" :rows="3" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { deleteDragonCategory, getDragonCategoryList, getDragonEventList, getDragonGroupOptions, saveDragonCategory } from '@/api'

export default {
  data() {
    return {
      query: { eventId: undefined },
      eventOptions: [],
      groupOptions: [],
      data: [],
      loading: false,
      visible: false,
      form: {
        status: 1,
        sortOrder: 0
      },
      rules: {
        eventId: [{ required: true, message: '请选择赛事' }],
        categoryName: [{ required: true, message: '请输入组别名称' }]
      },
      columns: [
        { title: '所属赛事', dataIndex: 'eventId', customRender: value => this.getEventTitle(value) },
        { title: '所属分组', key: 'groupName', scopedSlots: { customRender: 'groupName' } },
        { title: '组别名称', dataIndex: 'categoryName' },
        { title: '排序', dataIndex: 'sortOrder', width: 90 },
        { title: '状态', dataIndex: 'status', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 160, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadEvents()
    this.loadGroups()
    this.loadData()
  },
  methods: {
    loadEvents() {
      getDragonEventList({ page: 1, pageSize: 200 }).then(res => {
        this.eventOptions = res.data.list || []
      })
    },
    loadGroups() {
      getDragonGroupOptions().then(res => {
        this.groupOptions = res.data || []
      })
    },
    getEventTitle(eventId) {
      const event = this.eventOptions.find(item => item.id === eventId)
      return event ? event.title : ''
    },
    getGroupName(groupId) {
      if (!groupId) return ''
      const group = this.groupOptions.find(item => item.id === groupId)
      return group ? group.groupName : ''
    },
    loadData() {
      this.loading = true
      getDragonCategoryList({ eventId: this.query.eventId }).then(res => {
        this.data = res.data.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    handleAdd() {
      this.form = {
        eventId: this.query.eventId,
        status: 1,
        sortOrder: 0
      }
      this.visible = true
    },
    handleEdit(record) {
      this.form = { ...record }
      this.visible = true
    },
    handleOk() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        saveDragonCategory(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.loadData()
        })
      })
    },
    handleDelete(id) {
      deleteDragonCategory({ id }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      })
    }
  }
}
</script>
